module.exports = __webpack_public_path__ + "static/media/kdsa_logo.26b05f7e.zip";